import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { find, get, isEmpty } from "lodash";
import {
  ManagePlanLayout,
  AddPlans,
  CsplTable as Table,
  LoaderWrapper,
} from "../../../components";
import {
  FLOW_TYPES,
  MANAGE_PLAN_ROUTES,
  getPathWithParam,
  getAdvancedPathWithParam,
  OPTIONS_DATA_MAPPER,
  toMultiSelectValueById,
  tranformListToDropdownValues,
} from "../../../utils";
import { listEntryDate, listSource } from "../../../services";
import { useRouterParams, useRequest, useDeepEffect } from "../../../abstracts";
import { clearLocalCacheByModel, createPlanStore } from "../../../contexts";
import AddToolTip from "../../../components/AddToolTip";
import { useState } from "react";

const columns = [
  {
    label: "Entry Date Name",
    className: "column-entryDateName",
    columnName: "ruleName",
    link: `${MANAGE_PLAN_ROUTES.ADD_ENTRYDATECLASSIFICATION}`,
  },
  {
    label: "Entry Date For",
    className: "column-entryDateFor",
    columnName: "entryDateRuleFor",
    dataMapper: OPTIONS_DATA_MAPPER.ENTRYDATECLASSIFICATION_TYPE,
  },
  {
    label: "Entry Date Criteria",
    className: "column-entryDateCriteriaFor",
    columnName: "entryDateRule",
    dataMapper: OPTIONS_DATA_MAPPER.ENTRYDATECLASSIFICATION_CRITERIA,
  },
  {
    label: "Additional Rule",
    className: "column-additionalRule",
    columnName: "additionalRule",
    dataMapper:
      OPTIONS_DATA_MAPPER.ENTRYDATECLASSIFICATION_PROSPECTIVEORRETROSPECTIVE,
  },
];

const EntryDateClassification = (props) => {
  const { flow, planId } = useRouterParams();
  const { state, dispatch } = useContext(createPlanStore);
  const { response: data, loading: load } = useRequest({
    method: listEntryDate,
    payload: parseInt(planId),
    defaultResponse: [],
  });
  const planData = get(state, "api.reviewAndPlanDetail", {});

  const { response: sourcesData, loading: loader } = useRequest({
    method: listSource,
    payload: parseInt(planId),
    defaultResponse: [],
  });
  const sources = get(sourcesData, "employerSourcesList", []);
  const entryDateClassificationData = get(data, "entryDateRules", []);
  useEffect(() => {
    dispatch(clearLocalCacheByModel("entryDateRules"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onAddClick = () => {
    const { history } = props;

    history.push(
      getAdvancedPathWithParam({
        path: MANAGE_PLAN_ROUTES.ADD_ENTRYDATECLASSIFICATION,
        pathParam: [FLOW_TYPES.ADD, planId, 0],
      })
    );
  };

  const buttons = [
    {
      label: "Add",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.EDIT, FLOW_TYPES.SAVE],
      onClick: onAddClick,
    },
    // {
    //   label: "",
    //   variant: "secondary",
    //   type: "button",
    //   flow: [FLOW_TYPES.ADD, FLOW_TYPES.EDIT, FLOW_TYPES.SAVE],
    //   isAddButton: true,
    //   onClick: onAddClick,
    // },
  ];

  return (
    <ManagePlanLayout buttons={buttons} pageFlow={flow}>
      <LoaderWrapper isLoading={load}>
        {isEmpty(entryDateClassificationData) && (
          <AddPlans
            menu="plan"
            subMenu="entryDateClassification"
            content="No Entry Dates"
            buttonLabel="Add Entry Date"
            link={getAdvancedPathWithParam({
              path: MANAGE_PLAN_ROUTES.ADD_ENTRYDATECLASSIFICATION,
              pathParam: [FLOW_TYPES.SAVE, planId, 0],
            })}
          />
        )}
        {!isEmpty(entryDateClassificationData) && (
          <div className="w-100">
            <div className="d-flex w-100 align-items-center justify-content-between mb-4">
              <div className="m-0 plan-heading font-weight-500">
                Manage Entry Date
              </div>
            </div>
            <Table>
              <Table.Thead>
                <Table.Tr>
                  {columns.map((item, index) => {
                    return (
                      <Table.Th key={index} className={item.className}>
                        {item.label}
                      </Table.Th>
                    );
                  })}
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {entryDateClassificationData.map((entryDate, index) => {
                  return (
                    <Table.Tr key={index}>
                      {columns.map((item, cellIndex) => {
                        return (
                          <Table.Td key={cellIndex} className={item.className}>
                            {!isEmpty(item.link) ? (
                              <Link
                                to={getAdvancedPathWithParam({
                                  path: item.link,
                                  pathParam: [
                                    FLOW_TYPES.EDIT,
                                    planId,
                                    entryDate.id,
                                  ],
                                })}
                              >
                                {entryDate[item.columnName].length > 20 ? (
                                  <AddToolTip name={entryDate[item.columnName]}>
                                    {(entryDate[item.columnName] || "").slice(
                                      0,
                                      20
                                    )}
                                    ...
                                  </AddToolTip>
                                ) : (
                                  entryDate[item.columnName]
                                )}
                              </Link>
                            ) : item.columnName == "entryDateRule" ? (
                              entryDate?.prospectiveOrRetrospective ? (
                                item.dataMapper[entryDate[item.columnName]] +
                                " - " +
                                OPTIONS_DATA_MAPPER
                                  .ENTRYDATECLASSIFICATION_PROSPECTIVEORRETROSPECTIVE[
                                  entryDate?.prospectiveOrRetrospective
                                ]
                              ) : (
                                item.dataMapper[entryDate[item.columnName]]
                              )
                            ) : item.columnName == "entryDateRuleFor" ? (
                              entryDate[item.columnName] == 1 ? (
                                item.dataMapper[entryDate[item.columnName]] +
                                " - " +
                                get(planData, "planName")
                              ) : (
                                <AddToolTip
                                  name={
                                    item.dataMapper[
                                      entryDate[item.columnName]
                                    ] +
                                    " - " +
                                    sources
                                      ?.filter((source, ind) => {
                                        return entryDate.entryDateSources?.some(
                                          (item, i) => {
                                            return source.id == item.sourceId;
                                          }
                                        );
                                      })
                                      .map((e) => {
                                        return e.sourceName;
                                      })
                                      .join(",")
                                  }
                                />
                              )
                            ) : isEmpty(entryDate.additionalEntryDateRules) ? (
                              "No"
                            ) : (
                              "Yes"
                            )}
                          </Table.Td>
                        );
                      })}
                    </Table.Tr>
                  );
                })}
              </Table.Tbody>
            </Table>
          </div>
        )}
      </LoaderWrapper>
    </ManagePlanLayout>
  );
};

export default EntryDateClassification;
